module.exports = __webpack_public_path__ + "img/202308_01.f371a9f0.jpg";